import React from 'react';
import { CheckCircle2, XCircle, AlertTriangle, Info, MinusCircle } from 'lucide-react';

// One place for how a check status looks, so the summary, the issue list and every check row agree.
export const STATUS = {
  pass: { label: 'Pass', icon: CheckCircle2, color: '#2E844A', badge: 'sf-badge-success', soft: 'bg-[#EBF3ED] border-[#C4DCC8]' },
  warn: { label: 'Warning', icon: AlertTriangle, color: '#DD7A01', badge: 'sf-badge-warning', soft: 'bg-[#FFF4E5] border-[#FFCD94]' },
  fail: { label: 'Failed', icon: XCircle, color: '#BA0517', badge: 'sf-badge-error', soft: 'bg-[#FDE7E9] border-[#F6A3AB]' },
  info: { label: 'Info', icon: Info, color: '#0176D3', badge: 'sf-badge-manager', soft: 'bg-[#EAF4FE] border-[#B8DAF3]' },
  skip: { label: 'Skipped', icon: MinusCircle, color: '#9A9894', badge: 'sf-badge-neutral', soft: 'bg-[#F3F2F2] border-[#D8DDE6]' },
};

export function StatusIcon({ status, size = 18 }) {
  const s = STATUS[status] || STATUS.skip;
  const Icon = s.icon;
  return <Icon size={size} style={{ color: s.color }} className="shrink-0" aria-label={s.label} />;
}

export const GROUP_ORDER = ['config', 'token', 'waba', 'phone', 'webhook', 'templates', 'delivery'];

// Plain-text report a tenant can paste to support or to Meta. Everything in it was already redacted server-side.
export function buildReportText(report) {
  if (!report) return '';
  const L = [];
  L.push('WhatsApp diagnostics report');
  L.push(`Generated: ${report.generatedAt}  |  Graph API ${report.apiVersion}  |  Verdict: ${report.summary.verdict.toUpperCase()}`);
  const c = report.context;
  if (c) L.push(`Phone Number ID: ${c.phoneNumberId}  |  WABA ID: ${c.wabaId}  |  App ID: ${c.appId || 'unknown'}  |  Mode: ${c.mode}`);
  L.push(`Pass ${report.summary.pass}  Warn ${report.summary.warn}  Fail ${report.summary.fail}  Skipped ${report.summary.skip}`);
  L.push('');
  for (const g of report.groups) {
    L.push(`== ${g.title} ==`);
    for (const k of g.checks) {
      L.push(`[${k.status.toUpperCase()}] ${k.title}: ${k.summary}`);
      if (k.hint && (k.status === 'fail' || k.status === 'warn')) L.push(`    Fix: ${k.hint}`);
      for (const d of k.details || []) if (/fbtrace|Error code|Meta said/i.test(d.label)) L.push(`    ${d.label}: ${d.value}`);
    }
    L.push('');
  }
  return L.join('\n');
}
